import styled from "@emotion/styled";
import { Button } from "@mui/material";
import COLORS from "../../../../../theme/Colors";
import FONTS_FAMILY from "../../../../../theme/FontsFamily";

export const ButtonContainer = styled('div')({
  width: '200px',
  marginTop: '20px',
  "@media (min-width:320px)": {
    width: "175px",
  },
});

export const DefaultButton = styled(Button)({
  color: COLORS.white,
  backgroundColor: COLORS.primary,
  borderRadius: "17px",
  fontSize: "15px !important",
  height: '38px',
  fontFamily: FONTS_FAMILY.medium.title,
  "&:hover,&:focus,&:active": {
    color: COLORS.white,
    backgroundColor: COLORS.grayHover,
  },
  "@media (min-width:320px)": {
    fontSize: "13px !important",
    width: "90%",
  },
  "@media (min-width:768px)": {

    width: "210px",
  },
  "@media (min-width:1200px)": {
    fontSize: "16px !important",
    width: "230px",
  },
});